import React, { useEffect, useCallback, Fragment } from 'react';
import { Space, Button } from 'antd';
import { useWidget } from './useWidget';
import NetworkAccountSelect from 'components/Selects/NetworkAccountSelect/NetworkAccountSelect';
import StatusSelect from 'components/Selects/StatusSelect';
import StoreSelect from 'components/Selects/StoreSelect';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import AdSelect from 'components/Selects/AdSelect';
import AdsetNameSelect from 'components/Selects/AdsetNameSelect';
import CampaignSelect from 'components/Selects/CampaignSelect';
import IntegrationsSelect from 'components/Selects/IntegrationsSelect';
import DateFilter from './components/DateFilter';
import EditWidgetTitle from './components/EditWidgetTitle';

const WidgetFilter = ({}) => {
  const {
    showIntegrationFilters = false,
    disableStatusFilter,
    disableAccountsFilter,
    default_filter,
    widget_key,
    filters,
    setFilters,
    runFilter,
    networkSwitch,
    network,
    adsFilter,
    adsetFilter,
    campaignFilter,
    integrationsSelect = false,
    filterComponent: FilterComponent = Fragment,
    configuration,
    defaultFilter,
    setDefaultFilter,
  } = useWidget();

  const { setDate } = useWidgetDate(widget_key);
  const {
    date_from: globalDateFrom,
    date_to: globalDateTo,
    date_range_key: globalKey,
  } = useWidgetDate('global');

  const handleFilters = (key, value) => {
    setDefaultFilter((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const resetFilter = useCallback(() => {
    setDefaultFilter({ ...default_filter });
    setFilters({ ...default_filter });

    if (default_filter.date_from || default_filter.date_range_key) {
      setDate({
        date_from: default_filter.date_from,
        date_to: default_filter.date_to,
        date_range_key: default_filter.date_range_key,
      });
    } else {
      setDate({
        date_from: globalDateFrom,
        date_to: globalDateTo,
        date_range_key: globalKey,
      });
    }
    runFilter();
  }, [default_filter, setFilters, setDate, runFilter]);

  const handlerunfilter = () => {
    setFilters({ ...defaultFilter });
    runFilter();
  };

  return (
    <Space direction='vertical' className='w-full my-2'>
      {!configuration && <EditWidgetTitle />}
      <DateFilter handleFilters={handleFilters} />
      {adsFilter && (
        <AdSelect
          networkSwitch={networkSwitch}
          network={network}
          className='w-full'
          multiple
          value={defaultFilter?.ad_ids ?? []}
          onChange={(ids) => {
            handleFilters('ad_ids', ids);
          }}
        />
      )}
      <FilterComponent />
      {adsetFilter && (
        <AdsetNameSelect
          networkSwitch={networkSwitch}
          network={network}
          className='w-full'
          multiple
          value={defaultFilter?.adset_ids ?? []}
          onChange={(ids) => {
            handleFilters('adset_ids', ids);
          }}
        />
      )}
      {campaignFilter && (
        <CampaignSelect
          networkSwitch={networkSwitch}
          network={network}
          className='w-full'
          multiple
          value={defaultFilter?.campaign_ids ?? []}
          onChange={(ids) => {
            handleFilters('campaign_ids', ids);
          }}
        />
      )}
      {!disableStatusFilter && (
        <div className='h-full col-span-2 md:col-span-1'>
          <StatusSelect
            value={defaultFilter.statuses}
            onChange={(statuses) => {
              handleFilters('statuses', statuses);
            }}
            className='h-full'
          />
        </div>
      )}
      {!disableAccountsFilter && (
        <NetworkAccountSelect
          networkSwitch={networkSwitch}
          network={network}
          value={defaultFilter?.network_account_ids}
          onChange={(account_ids) => {
            handleFilters('network_account_ids', account_ids);
          }}
          maxTagCount={10}
        />
      )}
      {integrationsSelect && (
        <IntegrationsSelect
          mode={false}
          value={defaultFilter?.integration_type || []}
          onChange={(val) => {
            handleFilters('integration_type', val);
          }}
        />
      )}
      {showIntegrationFilters ? (
        <StoreSelect
          disableStoreSwitch
          integration={defaultFilter?.integration || defaultFilter?.integration_type || 'all'}
          handleChanges={(ids) => {
            handleFilters('integration_ids', ids);
          }}
          value={defaultFilter?.integration_ids || []}
        />
      ) : null}
      {configuration && (
        <div className='flex items-center justify-end col-span-12 gap-2 mt-2'>
          <div className='flex items-center gap-4 mr-2'>
            <Button onClick={handlerunfilter} type='primary'>
              Filter
            </Button>
            <Button
              icon={<img src='/icons/reset-orange.svg' className='w-3 h-3' />}
              onClick={resetFilter}
            >
              Reset
            </Button>
          </div>
        </div>
      )}
    </Space>
  );
};

export default WidgetFilter;
